export const initPropertyTitle = () => {
  const postTitle = document.querySelector(
    '.property .property-title .et_pb_text_inner',
  );
  if (postTitle) {
    const h1 = document.createElement('h1');
    h1.innerHTML = postTitle.innerHTML;
    postTitle.parentNode.replaceChild(h1, postTitle);
  }
};
